// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"6973d780","504":"f44f1b45","907":"14dfdb20"}[chunkId] + ".chunk.css";
};